import React from 'react'
import { Imgix } from '@elements'

export const HeroOne = ({
  heroHeadlineRow1,
  heroHeadlineRow2,
  heroHeadlineRow2Underlined,
  heroHeadlineRow3,
  backgroundImage,
}) => {
  return (
    <section className="mt-4 bg-white sm:mt-10 md:mt-16 lg:mt-0">
      <div className="container flex flex-wrap">
        <div className="items-center w-full pl-6 lg:w-5/12 sm:pl-12 md:pl-20 lg:pl-0 xl:pl-0 lg:-mt-10 xl:-mt-16 lg:flex">
          <h1 className="font-sans text-4xl font-bold text-left text-gray-400 uppercase sm:text-5xl md:text-6xl xl:text-7xl">
            <span className="block ml-12 leading-none sm:ml-16 md:ml-20">
              {heroHeadlineRow1}
            </span>
            <span className="block">
              {heroHeadlineRow2}{' '}
              <span className="inline-block text-2xl font-normal leading-tight transform -translate-y-1 border-gray-400 font-display sm:text-3xl md:text-4xl xl:text-5xl border-b-6 md:border-b-8 xl:-translate-y-3">
                {heroHeadlineRow2Underlined}
              </span>
            </span>
            <span className="block ml-12 leading-none sm:ml-16 md:ml-20">
              {heroHeadlineRow3}
            </span>
          </h1>
        </div>
        <div className="w-full lg:w-7/12">
          <Imgix
            src={backgroundImage.mediaItemUrl}
            sizes="(min-width: 1024px) 41.6vw, 100vw"
            alt={backgroundImage.altText}
            className="w-full h-auto sm:w-4/5 sm:ml-auto md:w-3/4 lg:w-full"
          />
        </div>
      </div>
    </section>
  )
}
